/* @flow */

import React from 'react';
import { Col, Row } from 'reactstrap';
import { Paper, InfoTooltip, BookProgress } from '../components/';
import {
  DataDisplayParentContainer, IntelligencesTopicContainer, IntelligencesProgressContainer,
  ActivityFeedContainer, HeaderContainer, PageTitleContainer,
  SignInFormContainer
} from '../containers/';
import '../../css/main.css';
import Translations from '../hocs/TranslationsHelper';
import topScroll from '../hocs/topScroll';
import {useData} from '../hocs/DataRetriever'
import { useSelector } from 'react-redux';
import { getActiveChild } from '../../selectors/children';
import { getCaligrafixBookProgressById } from '../../selectors/caligrafixBookProgress';
import _ from 'lodash';

const getCaligrafixBooksProgress = ( currentProgress, caligrafixBooks  ) => {
  return _.map(currentProgress, ({caligrafix_book_id, score})=>(
    {
      id: caligrafix_book_id,
      slug: _.find(caligrafixBooks, (b)=>(b.id==caligrafix_book_id))?.slug,
      value: parseInt(score,10)
    }
  ))
 
};

const LoggedSc = ({ queryParams, translations }) => {
  const currentChild = useSelector(getActiveChild);

  console.log("ch: ", currentChild);

  const caligrafix_books_data = useData({id: "child_caligrafix_books_"+currentChild.id, url: 
    "/children/"+currentChild.id+"/caligrafix_book_scores/current"  });
  const {  caligrafix_books} = useSelector(({ caligrafix_books })=>({  caligrafix_books}));
  const cx_progress = caligrafix_books_data.data?.body;
  let book_progress=[];
  if(cx_progress)
    book_progress=getCaligrafixBooksProgress(cx_progress,caligrafix_books);

  return (
    <div style={{
    display: "flex",
    flexDirection: "row", 
    padding: "15px",
    backgroundColor: "white"
    } } className='layout-base' >  
          <HeaderContainer disable_click/>
        <Row> 
            <Col xs="12" lg="8">
            <Paper.Title>
                <h1>{ translations.t('current_progress') }</h1>
            </Paper.Title>
            </Col>
          <Col xs="12" lg="4" className="hidden-md-down">
            <Paper.Title>
              <h1>{ translations.t('recent_activity') }</h1>
            </Paper.Title>
          </Col>
          
          <Col xs="12" lg="8">
            <Paper.Content>
              <IntelligencesProgressContainer />
            </Paper.Content>
          </Col>
          <Col xs="12" className="hidden-lg-up">
            <hr />
            <Paper.Title>
              <h1>{ translations.t('recent_activity') }</h1>
            </Paper.Title>
          </Col>
          <Col xs="12" lg="4">
            <Paper.Content>
              <ActivityFeedContainer />
            </Paper.Content>
          </Col>
          <Col lg="12" >
            <Paper.Title>
              <h1 className="mt-5">
                { translations.t('intelligences_progress_analysis') } {' '}
                <InfoTooltip message="tooltips_intelligences_progress_analysis" />
              </h1>
            </Paper.Title>
          </Col>
          
          <Col lg="12">
            <Paper.Content>
              <DataDisplayParentContainer />
            </Paper.Content>
          </Col>
           
          {
            (book_progress.length>0)&&(

              <Col lg="12" >
                <Paper.Title>
                  <h1 className="mt-5">{ translations.t('caligrafix_current_general_progress') }</h1>
                </Paper.Title>
              </Col>

            )
          }
          {
            (book_progress.length>0)&&( 

              <Col lg="12" >
                <Paper.Content>
                  <div>  
                    {book_progress.map((book,index) =>  <BookProgress key={book.id} slug={book.slug} value={book.value} /> )}
                  </div>
                </Paper.Content>
              </Col>
            )
          }
           </Row>
    </div>
  );
}
/**
 * Render Dashboard screen
 * @method Dashboard
 * @param  {object}                    translations - injected by our Translations HoC to give translated strings
 */
const BebegenProgress = ({ queryParams, translations }) => {
  topScroll();
  const isLogged = useSelector(({user})=> user.is_logged_in); 
  const currentChild = useSelector(getActiveChild); 
  const userLicense = useSelector(({user})=>user.license_type);
  console.log("ult: ", userLicense);

  if(!isLogged)
    
    return <div  
    style={
      {
        position: "absolute",
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }
    }>  
      <SignInFormContainer queryParams={queryParams} embedded={
        {
          title: "Progreso de recursos educativos Caligrafix + PleIQ",
          subtitle: "Inicia sesión con tu cuenta PleIQ"
        } 
      }/> 
    </div> ;
  else if(currentChild.id)
    return <LoggedSc queryParams={queryParams} translations={translations} />;
  else if( ["pleiq_school","pleiq_cx","pleiq_cx_plus" ].indexOf(userLicense)!=-1)
    return (
  
    <div style={{
    display: "flex",
    flexDirection: "row", 
    padding: "15px",
    backgroundColor: "white"
    } } className='layout-base' >  
          <HeaderContainer disable_click/>
        <div style={
          {
            display:  "flex",
            width: "100%",
            justifyContent: "center" 
          }
        }>  
          
          <Col xs="12" lg="8">
            <Paper.Content>
              <h5 style={{color:"red", textAlign: "center"} }>
                Atención
              </h5>
              <p style={{  textAlign: "center"} }>
                   Esta funcionalidad está disponible solo para cuentas familiares activadas con código.
                  <br/>
                  Por favor, cierre sesión e ingrese con una cuenta válida.
              </p>
            </Paper.Content>
          </Col>
        </div> 
      </div>
  
    ) 
  else
    return "cargando...";
};

export default Translations(BebegenProgress);
